const messages = {
    title: "Vedlikeholdsarbeid",
    description: "Nødvendig vedlikeholdsarbeid utføres for tiden på serverne." +
        "<br/><br/>Derfor er tilgangen til <b>BRIDGESTONE <span class=\"text-danger\">PLUS</span></b> " +
        "for øyeblikket utilgjengelig for deg.<br/><br/>Vi takker for din tålmodighet og forståelse." +
        "<br/><br/> Din Bridgestone-team"
}
export default {
    messages
}
